import { Grid, LinearProgress, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { usePackageWithId } from "../admin/packages/usePackageWithId";
import { useEcommerceOffer } from "../eCommerce/useECommerceOffer";
import ECommerceOfferDetails from "./details/ECommerceOfferDetails";
import { useECommerceOfferToProducts } from "./details/useECommerceOfferToProducts";

export function ECommerceOfferPage() {
  const navigate = useNavigate();
  const { data: offer, isLoading: isOfferLoading } = useEcommerceOffer();
  const { data: packageData, isLoading: isPackageLoading } = usePackageWithId(offer?.packageId);
  const { products, isLoading: areProductsLoading } = useECommerceOfferToProducts(offer);
  const isLoading = isPackageLoading || isOfferLoading || areProductsLoading;
  return (
    <>
      {isLoading && <LinearProgress />}
      {offer && packageData && products && (
        <ECommerceOfferDetails
          offer={offer}
          packageData={packageData}
          products={products}
          onBack={() => navigate("/e-commerce")}
        />
      )}
      {!isLoading && !offer && (
        <Grid
          container
          sx={{
            marginTop: 2,
            marginBottom: 2,
          }}
        >
          <Typography variant="h5">Taka oferta nie istnieje</Typography>
        </Grid>
      )}
    </>
  );
}
